import { ChangePasswordWizard } from '@identity/presentation/components/specific';
import { IdentityFlowProvider } from '@identity/presentation/context';

/**
 * The in-session password change, reached from Mi perfil.
 *
 * It checks nothing before rendering: its credential is the Parrot session, and the private route
 * already redirects to the login when there is none.
 */
export const ChangePasswordPage = () => (
  <IdentityFlowProvider flow="profile">
    <ChangePasswordWizard />
  </IdentityFlowProvider>
);
